import axios from "../api/apiConfig";
import { OrderDetailType, OrderMasterType } from "../customTypes/customTypes";

export const createOrder = async (order: OrderMasterType) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/order", order)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateOrder = async (order: OrderMasterType) => {
  return new Promise((resolve, reject) => {
    axios
      .put("/order", order)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const getAllOrders = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/order")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const findByOrderNo = async (order_no: string) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/order/${order_no}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateDetailRecord = async (obj: OrderDetailType | null) => {
  return new Promise((resolve, reject) => {
    axios
      .put("/order/detail", obj)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteDetailRecord = async (id: number) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(`/order/detail/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export default {
  createOrder,
  getAllOrders,
  findByOrderNo,
  updateDetailRecord,
  deleteDetailRecord,
};
